import {Component, Inject, OnInit, ChangeDetectionStrategy, inject} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SettingsService } from '@odin/odin-settings';
import { CognitoService } from '../../services/cognito-service';
import {ErrorReferenceService, HTTPCONSTANTS, OdinFeatures} from "@odin/odin-core";
import {HttpClient} from "@angular/common/http";
import LoginResponse from "../../models/login-request";

@Component({
  standalone: false,
  selector: 'odin-login-page',
  templateUrl: './login-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./login-page.component.scss'],
})
export class LoginPageComponent implements OnInit {
  public email = '';
  public password = '';
  public loggingIn = false;
  public errorMessage = '';
  public mfaConfig: undefined | LoginResponse;
  private errorReference = inject(ErrorReferenceService);

  public newLogin = false;
  public step: 'login' | 'mfa' = 'login';

  constructor(
    private httpClient: HttpClient,
    private router: Router,
    private settingsService: SettingsService,
    private cognitoService: CognitoService,
    private route: ActivatedRoute,
    @Inject('features') private featureHelper: OdinFeatures
  ) {
    this.newLogin = featureHelper["new-profile-login"];
  }

  ngOnInit(): void {
    if (!this.cognitoService.userLoggedIn()) {
      this.requiresSignIn();
      return;
    }
    const lastRoute = this.settingsService.GetNotNullSetting('lastRoute', '/dashboard');
    this.router.navigate([lastRoute.value]);
  }

  private requiresSignIn(): void {
    this.route.queryParams
      .subscribe(params => {
        if (params['auto'] == 'true') {
          this.Login();
        }
      }
    );
  }

  GoBack(): void {
    this.mfaConfig = undefined;
    this.step = 'login';
    this.errorMessage = '';
    this.email = '';
    this.password = '';
    this.loggingIn = false;
  }

  Login() {
    if (this.loggingIn) return;
    if (!this.newLogin) {
      this.loggingIn = true;
      this.cognitoService.login().catch(() => {
        this.loggingIn = false;
      });
      return;
    }

    if (this.email === '') return;
    if (this.password === '') return;
    this.loggingIn = true;

   this.httpClient.post<LoginResponse>(
     `${HTTPCONSTANTS.protocol}${HTTPCONSTANTS.baseAddress}/portal/odin-authentication/login`,
     {
     email: this.email,
     password: this.password
   }).subscribe((res: LoginResponse) => {
      // check if 2fa is required (it should always be, but to be sure)
      if (res.authenticationResult === null && res.challengeName !== null) {
        res.email = this.email;
        this.mfaConfig = {
          ...res
        };
        this.step = 'mfa';
        this.loggingIn = false;
      } else {
        // unhandled

        this.loggingIn = false;
        const message = 'Failed to login, something went wrong.';
        this.errorMessage = this.errorReference.formatMessage(message, new Error(message));
      }
   }, (err: unknown) => {
      this.loggingIn = false;
      this.errorMessage = this.errorReference.formatMessage('Failed to login, please check your email and password.', err);
   });
  }

  Logout() {
    this.cognitoService.logout();
  }
}
